import { apiClient, type ShipmentBundleResultEntity } from '@/libs/api'

export type CreateShipmentBundleRequest = {
  tenantKey: string
  shipmentOrderIds: number[]
  /** 全依頼に揃える発日。未指定なら各依頼の発日を維持する */
  shippingDate?: string
  /** 全依頼に揃える着日。未指定なら各依頼の着日を維持する */
  deliveryDate?: string
  /** 請求計上日の扱い。FOLLOW=発日・着日から再算出（既定）/ ALIGN=揃える / KEEP=据え置き */
  incomeRecordingDateHandling?: 'FOLLOW' | 'ALIGN' | 'KEEP'
  /** 全依頼に揃える請求計上日（ALIGN のとき必須） */
  incomeRecordingDate?: string
}

export const createShipmentBundle = async ({
  tenantKey,
  shipmentOrderIds,
  shippingDate,
  deliveryDate,
  incomeRecordingDateHandling,
  incomeRecordingDate
}: CreateShipmentBundleRequest): Promise<ShipmentBundleResultEntity> => {
  const response = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.bundles.$post({
      body: {
        shipmentOrderIds,
        shippingDate,
        deliveryDate,
        incomeRecordingDateHandling,
        incomeRecordingDate
      }
    })
  return response.data
}
